__turbopack_context__.v({
  "band": "styles-module__6Cyxoq__band",
  "body": "styles-module__6Cyxoq__body",
  "check": "styles-module__6Cyxoq__check",
  "cta": "styles-module__6Cyxoq__cta",
  "heading": "styles-module__6Cyxoq__heading",
  "highlight": "styles-module__6Cyxoq__highlight",
  "item": "styles-module__6Cyxoq__item",
  "list": "styles-module__6Cyxoq__list",
  "payout": "styles-module__6Cyxoq__payout",
  "payoutBig": "styles-module__6Cyxoq__payoutBig",
  "payoutLabel": "styles-module__6Cyxoq__payoutLabel",
  "payoutRow": "styles-module__6Cyxoq__payoutRow",
  "payoutVal": "styles-module__6Cyxoq__payoutVal",
  "payoutValHighlight": "styles-module__6Cyxoq__payoutValHighlight",
  "root": "styles-module__6Cyxoq__root",
});
